<div [class.smart-assistant-module-collapse]="isCollapse" [style.max-height]="maxHeight">
    <span *ngIf="showImage" class="file-share-title">{{i18n.createFileShareTitle}}</span>

    <!-- 轮播图 -->
    <app-smart-assistant-gif-container *ngIf="showImage" [subTitle]="subTitle"
        [gifTips]="str.fileShareGifTips" imagePrefix="file-share">
    </app-smart-assistant-gif-container>

    <ng-container *ngIf="hasShareWritePermission">

        <!-- 帮助提示（NFS和CIFS数量都为0，则不显示文字） -->
        <div class="file-share-help-container" *ngIf="nfsDatas.length !== 0 || (cifsDatas.length !== 0 && !ProductConfig.isHideCifs)">
            <app-smart-assistant-switch [content]="i18n.helpTitle" [showIcon]="false"></app-smart-assistant-switch>
            <span class="sub">{{i18n.helpText}}</span>
        </div>

        <!-- NFS/CIFS共享对象 -->
        <div class="file-share-object-container">
            <n-loading [visible]="loading"></n-loading>
            <!-- NFS共享 -->
            <div class="file-share-object-container-nfs" *ngIf="nfsDatas.length !== 0">
                <span class="sub-text">{{i18n.nfsLabel}}</span>
                <!-- 如果没有CIFS共享，则显示10条NFS，否则显示5条 -->
                <app-smart-assistant-object-container icon="#app-icon-simple-nfs"
                    *ngFor="let nfs of (cifsDatas.length === 0 ? nfsDatas : nfsDatas.slice(0, 5)); index as i"
                    [id]="'file-share-object-nfs-' + i"
                    [name]="nfs.NAME"
                    [operateLabel]="i18n.setPermission"
                    (onClick)="nfsAddPermission(nfs)">
                </app-smart-assistant-object-container>
            </div>

            <!-- CIFS共享 -->
            <div class="file-share-object-container-cifs" *ngIf="cifsDatas.length !== 0 && !ProductConfig.isHideCifs">
                <span class="sub-text">{{i18n.cifsLabel}}</span>
                <!-- 如果没有NFS共享，则显示10条CIFS，否则显示5条 -->
                <app-smart-assistant-object-container icon="#app-icon-simple-cifs"
                    *ngFor="let cifs of (nfsDatas.length === 0 ? cifsDatas : cifsDatas.slice(0, 5)); index as i"
                    [id]="'file-share-object-cifs-' + i"
                    [name]="cifs.NAME"
                    [operateLabel]="i18n.setPermission"
                    (onClick)="cifsAddPermission(cifs)">
                </app-smart-assistant-object-container>
            </div>
        </div>
    </ng-container>
</div>
